import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@material-ui/core";
import { AppContext } from "../../Context/AppContextProvide";

export default function SignInAlert(props) {
  // Reuse the account-creation toggle already fetched app-wide (canCreate) instead
  // of issuing another /customer/account/create/status request per product load.
  const { canCreate: userRegSwitchState } = useContext(AppContext);

  return (
    <Dialog
      open={props.isOpen}
      onClose={() => props.onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Account Required</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="body1">
            An account is required to add products to your favorites list or request to check out product
            samples. Please create an account or sign in to continue.
          </Typography>
          <Typography variant="body1" style={{marginTop: "10px"}}>
            If you would like to request a sample checkout without an account, please speak with a sales associate.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => props.onClose()}>
          Close
        </Button>
        { userRegSwitchState ? (
            <Button 
              variant="contained" 
              style={{backgroundColor: "#4caf50", color: "#FFFFFF"}}
              onClick={() => {
                window.location.href = '/register';
                props.onClose();
              }}
            >
              Create Account
            </Button> 
          ) : undefined }
        <Button 
          variant="contained" 
          onClick={() => {
            window.location.href = '/signin';
            const path = /^(\/$)|(\/signin)|(\/auth)|(\/register)|(\/confirm-user)|(\/forgotpass)|(\/resetpass)|(\/notfound)/.test(window.location.pathname) ? '' : window.location.pathname;
            localStorage.setItem('returnUrl', path);
            props.onClose();
          }}
          style={{backgroundColor: "#142e3e", color: "#28c4fc"}}
        >
          Sign In
        </Button>
      </DialogActions>
    </Dialog>
  );
};